import React from 'react';
import { Button, TextLabel } from '@wix/wix-base-ui';
import * as symbols from '@wix/santa-editor-symbols';
import * as util from '@/util';
import { translate } from '@/i18n';
import * as stateManagement from '@/stateManagement';
import ascendBi from '../common/bi/ascendBi';
import * as utils from '../common/utils';

interface UpgradeAscendPanelProps {
  navigateToAnalytics: any;
  sendBi(event: object, parameters: object): void;
  biBaseParams: any;
}

class AnalyticsPanel extends React.Component<UpgradeAscendPanelProps> {
  componentDidMount() {
    const { sendBi, biBaseParams } = this.props;

    sendBi(ascendBi.events.TAB_VIEW, {
      ...biBaseParams,
      tab_name: 'Analytics',
    });
  }

  render() {
    const { navigateToAnalytics, sendBi, biBaseParams } = this.props;
    const symbolName = util.workspace.isNewWorkspaceEnabled()
      ? 'ascendAnalyticsPanelLogo_NewWorkspace'
      : 'ascendAnalyticsPanelLogo';

    return (
      <div className="super-app-extra-panel">
        <div className="analytics-panel">
          <div className="body">
            <symbols.symbol name={symbolName} className="logo" />
            <div className="title">
              <TextLabel value="AscendButton_Analytics_Title" type="T09" />
            </div>
            <div className="subtitle">
              <TextLabel
                value="AscendButton_Analytics_Description"
                type="T07"
                enableEllipsis={false}
              />
            </div>
            <Button
              onClick={() => {
                sendBi(ascendBi.events.PRODUCT_CLICK, {
                  ...biBaseParams,
                  tab_name: 'Analytics',
                  product_name: 'Analytics',
                });
                navigateToAnalytics();
              }}
              className="analytics-button btn-md"
            >
              {translate('AscendButton_Analytics_Button')}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const getEditorAPI = (
  dispatch: AnyFixMe,
  getState: AnyFixMe,
  { editorAPI }: AnyFixMe,
) => editorAPI;

const mapStateToProps = ({ editorAPI, state }: AnyFixMe) => {
  return {
    biBaseParams: ascendBi.biUtils.getBiBaseParams({ editorAPI, state }),
  };
};

const mapDispatchToProps = (dispatch: AnyFixMe) => {
  const editorAPI = dispatch(getEditorAPI);
  return {
    navigateToAnalytics: () => utils.navigateToAscend(editorAPI, 'Analytics'),
    sendBi: (event: AnyFixMe, parameters: AnyFixMe) =>
      dispatch(stateManagement.bi.actions.event(event, parameters)),
  };
};

export default util.hoc.connect(
  util.hoc.STORES.EDITOR_API,
  mapStateToProps,
  mapDispatchToProps,
)(AnalyticsPanel);
